<template>
  <div style="height: 100%; background-color: #fff">
    <!-- <div class="chat_input_header">
      <RoundTabs ref="roundTabs" />
      <div
        v-if="douyinImageCategoryList.length && circle_id == 66"
        class="dy_entrances"
      >
        <div
          v-for="(item, index) in douyinImageCategoryList"
          :key="index"
          class="dy_entrance"
          @click="$openNewTab(`/circleV2/douyinImage?id=${item.id}`)"
        >
          <img
            class="icon_dy_img"
            src="@/assets/img/circleV2/icon_dy_img.png"
            alt=""
          />
          {{ item.name }}
        </div>
      </div>
    </div> -->
    <div class="chat_input_body_div">
      <div class="chat_upload_images_box">
        <UploadImages ref="uploadImages"></UploadImages>
      </div>
      <div class="chat_input_body">
        <template v-if="circleTalkStatus && userTalkStatus">
          <div v-if="replyInfo.id" class="reply_content">
            <div class="hang1">
              <div
                class="reply_content_text"
                v-html="`${replyInfo.user.nickname}：${replyInfo.content}`"
              />
            </div>
            <el-icon
              title="关闭引用"
              class="icon_close el-icon-close"
              @click="setReplyInfo({})"
              ><Close
            /></el-icon>
          </div>
          <div class="textarea_div" :class="{ has_reply: replyInfo.id }">
            <!-- <textarea
          id=""
          v-model="textarea"
          name=""
          cols="30"
          rows="10"
          placeholder="有想法就表达呦～"
          @keyup.enter="privateChatSend()"
        /> -->
            <el-input
              ref="targetInput"
              v-model="textarea"
              resize="none"
              type="textarea"
              :placeholder="placeholder"
              @keydown.enter="handleEnter($event)"
              :autofocus="true"
              id="testInput"
            />
          </div>
        </template>
        <div v-else class="textarea_div" style="color: #999">
          <span v-if="!circleTalkStatus">全员</span>禁言中
        </div>
        <div class="chat_input_handle_box">
          <div class="icons">
            <img
              v-if="!circleTalkStatus || !userTalkStatus"
              class="icon_emoji"
              src="@/assets/img/circleV2/icon_emoji.png"
              alt=""
              title="表情"
            />
            <template v-else>
              <EmojiNew @input="changeInput" @input2="sendEmojiImage">
                <img
                  class="icon_emoji"
                  src="@/assets/img/circleV2/icon_emoji.png"
                  alt=""
                  title="表情"
                />
              </EmojiNew>
            </template>

            <div>
              <el-select
                v-model="symbol"
                filterable
                :filter-method="customSearch"
                clearable
                placeholder="请选择品种"
                @change="handleSearch"
                @clear="clear"
              >
                <el-option
                  v-for="item in oneList"
                  :key="item.symbol"
                  :label="item.name"
                  :value="item.symbol"
                />
              </el-select>
            </div>
            <div>
              <span class="mr5">是否公开</span>
              <el-switch
                v-model="message_open"
                size="small"
                :active-value="1"
                :inactive-value="0"
                active-color="#4571e7"
                inactive-color="#BFBFBF"
              />
            </div>
            <!-- <img
            class="icon_calculator"
            src="@/assets/img/circleV2/icon_calculator.png"
            alt=""
            title="K线计算器"
            @click="$refs.KLineCalculator.showCalculator()"
          /> -->
          </div>
          <div class="handles">
            <span class="send_tip">Enter 发送，Ctr+Enter 换行</span>
            <div
              class="btn_submit"
              :class="{
                btn_submit_disabled: !circleTalkStatus || !userTalkStatus,
              }"
              @click="privateChatSend"
            >
              发送
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <KLineCalculator ref="KLineCalculator" /> -->
  </div>
</template>

<script>
import request from "@/utils/request";
import { Debounce } from "@/utils/debounce";
import socket from "@/utils/socket";
import RoundTabs from "@/components/circleV2/RoundTabs.vue";
// import KLineCalculator from "@/components/circleV2/KLineCalculator.vue";
export default {
  components: {
    RoundTabs,
    // KLineCalculator,
  },
  props: {
    circle_id: {
      type: Number,
      default: Number,
    },
    circleTalkStatus: {
      type: Number,
      default: 1,
    },
    userTalkStatus: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      textarea: "",
      replyInfo: {
        user: {},
      },
      question: 0, // 向老师提问:0否1是
      douyinImageCategoryList: [],
      // circleTalkStatus: 1,
      // userTalkStatus: 1,
      oneListOrigin: [],
      oneList: [],
      symbol: "",
      symbolName: "",
      message_open: 1, //回复消息是否公开:1开启0关闭
    };
  },
  computed: {
    placeholder() {
      return this.question ? "快来向老师提问吧~" : "快来参与圈友互动吧~";
    },
  },
  watch: {
    circle_id() {
      // this.getCategoryList();
    },
    circleTalkStatus() {
      // this.getCategoryList()
    },
    userTalkStatus() {
      // this.getCategoryList()
    },
  },
  mounted() {
    const that = this;
    window.addEventListener("circleChatHandleReplay", function (event) {
      that.setReplyInfo(event.detail.info);
    });
    this.getSymbolList();
    // this.getCategoryList();
    // console.warn("=======加载");
    this.addEventListenerCopy("testInput");
  },
  methods: {
    handleAddEventListenerCopy(e) {
      if (e.type == "text") {
        this.changeInput(e.data);
      } else if (e.type == "img") {
        this.uploadBlob(e.data);
      }
    },
    async getSymbolList() {
      const res = await request.post("/vce_gm/v1/symbol_list");
      this.oneListOrigin = res.data.symbol_no_ex;
      this.oneList = res.data.symbol_no_ex;
    },
    customSearch(e) {
      this.oneList = this.oneListOrigin.filter((item) =>
        item.bbas_match_name.includes(e)
      );
    },
    handleSearch(e) {
      const oneListOrigin = this.oneListOrigin;
      this.symbolName = e
        ? oneListOrigin.filter((item) => item.symbol == e)[0].name
        : "";
    },
    clear() {
      this.symbol = "";
      this.symbolName = "";
      this.oneList = this.oneListOrigin;
    },
    uploadBlob(e) {
      this.$refs.uploadImages.uploadImagesBlob(e);
    },
    async getCategoryList() {
      const res = await request.post("/api/douyin_image/getCategoryList");
      this.douyinImageCategoryList = res.data;
    },
    restoreDefault(isChangeTo0 = false) {
      this.textarea = "";
      this.$refs.uploadImages.handleRemove();
      this.symbol = "";
      this.symbolName = "";
      this.setReplyInfo({});
      if (isChangeTo0) {
        // this.$refs.roundTabs.setTabs(0);
        // this.question = 0;
        // this.$refs.targetInput.focus();
      }
    },
    setReplyInfo(info) {
      if (Object.keys(info).length) {
        this.$refs.targetInput.focus();
        info.content = this.emojiReplace(
          info.content.replace(/<p>|<\/p>/g, ""),
          true
        );
        // if (info.question || info.reply_question) {
        //   this.$refs.roundTabs.setTabs(1);
        //   this.question = 1;
        //   this.$refs.targetInput.focus();
        // } else {
        //   this.$refs.roundTabs.setTabs(0);
        //   this.question = 0;
        //   this.$refs.targetInput.focus();
        // }
      }
      this.replyInfo = info;
    },
    handleEnter(event) {
      if (event.keyCode === 13) {
        if (!event.ctrlKey) {
          // console.log('回车发送=======', this.textarea)
          this.privateChatSend();
          event.preventDefault();
        } else {
          this.changeInput("\n");
        }
      }
    },
    privateChatSend: Debounce(async function () {
      const images = this.$refs.uploadImages.getImagesUrl();

      if (!this.circleTalkStatus || !this.userTalkStatus) {
        return false;
      }
      // 去除头尾空白、换行
      const textarea = this.textarea.replace(/^[\r\n]+|[\r\n]+$/g, "");
      if (!textarea && !images) {
        this.$message.error("不能发送空消息");
        this.textarea = "";
        return false;
      }

      // 校验敏感词
      // await request.post("/api/chat/checkContent", {
      //   content: textarea,
      // });
      let msgId = this.getMsgId();
      if (images) {
        const objImg = {
          type: "chat_teacher_send",
          to_user_id: this.circle_id,
          teacher_id: this.circle_id,
          content: "",
          chat_type: 4,
          config: {
            platform: "pushWeb",
          },
          reply_id: this.replyInfo.id,
          question: 0,
          symbol: this.symbol,
          symbol_name: this.symbolName,
          images,
          message_open: this.message_open,
          noAddImages: 1,
          msg_id: msgId,
        };
        this.$parent.queuePush(objImg);
        const ws = this.$store.state.ws;
        if (ws && ws.readyState === 1) {
          ws.send(JSON.stringify(objImg));
          this.isSend(msgId);
        } else {
          this.startReconnectForSend();
        }
        this.handleCirclePush({
          reply_id: this.replyInfo.id,
          content: "[图片]",
        });
      }
      msgId = this.getMsgId();
      if (textarea) {
        const objtext = {
          type: "chat_teacher_send",
          to_user_id: this.circle_id,
          teacher_id: this.circle_id,
          content: textarea,
          chat_type: 4,
          config: {
            platform: "pushWeb",
          },
          reply_id: this.replyInfo.id,
          question: 0,
          symbol: this.symbol,
          symbol_name: this.symbolName,
          images: "",
          message_open: this.message_open,
          msg_id: msgId,
        };
        this.$parent.queuePush(objtext);
        const ws = this.$store.state.ws;
        if (ws && ws.readyState === 1) {
          ws.send(JSON.stringify(objtext));
          this.isSend(msgId);
        } else {
          this.startReconnectForSend();
        }
        this.handleCirclePush({
          reply_id: this.replyInfo.id,
          content: textarea,
        });
      }

      this.restoreDefault();
      this.$refs.uploadImages.handleRemove();
    }),
    // 检测是否发送成功
    isSend(msgId) {
      setTimeout(() => {
        const isCz = this.$parent.queueMessage.has(msgId);
        // 发送失败
        if (isCz) {
          this.$parent.queuePushSus(msgId);
        }
      }, 5000);
    },
    // 重新发送
    retrySend(obj) {
      const ws = this.$store.state.ws;
      if (ws && ws.readyState === 1) {
        ws.send(JSON.stringify(obj));
        this.isSend(obj.msg_id);
        return true;
      } else {
        this.startReconnectForSend(true);
        return false;
      }
    },
    async handleCirclePush(e) {
      if (!e.reply_id) {
        return false;
      }
      const res = await request.post("/teacher/circle/circlePush", e);
    },
    getMsgId() {
      const timestamp = new Date().getTime();
      const randomNum1 = Math.floor(10000000 + Math.random() * 90000000);
      return timestamp.toString() + randomNum1.toString();
    },
    // changeQuestionStatus(e) {
    //   this.question = e;
    //   this.setReplyInfo({});
    //   this.$refs.targetInput.focus();
    // },
    changeInput(e) {
      const element = this.$refs.targetInput.$refs.textarea;
      const cursorPosition = element.selectionStart;
      const beforeText = element.value.substring(0, cursorPosition);
      const afterText = element.value.substring(cursorPosition);
      const finalText = beforeText + e + afterText;
      this.textarea = finalText;
      this.$refs.targetInput.focus();
    },
    sendEmojiImage(e) {
      const ws = this.$store.state.ws;
      const msgId = this.getMsgId();
      const obj = {
        type: "chat_teacher_send",
        to_user_id: this.circle_id,
        teacher_id: this.circle_id,
        content: e.title,
        chat_type: 4,
        config: {
          platform: "pushWeb",
        },
        reply_id: 0,
        question: 0,
        message_type: "emoji",
        images: e.image,
        msg_id: msgId,
      };
      if (ws && ws.readyState === 1) {
        ws.send(JSON.stringify(obj));
      } else {
        this.$parent.queuePush(obj);
        this.startReconnectForSend();
      }
    },
    startReconnectForSend(manualRetry) {
      const ws = this.$store.state.ws;
      if (ws && ws.readyState === 1) {
        return;
      }
      const self = this;
      socket.reconnectForSend(
        // onConnected
        function () {
          self.$parent.resendPendingMessages();
        },
        // onFailed - 第3次失败后显示重发按钮
        function () {
          self.$parent.markPendingAsFailed();
        },
        // manualRetry - 用户手动触发时立即连接
        !!manualRetry
      );
    },
    retrySendMessage() {
      this.startReconnectForSend(true);
    },
  },
};
</script>

<style scoped>
.chat_input_header {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dy_entrances {
  flex-shrink: 0;
  height: 100%;
  display: flex;
  align-items: center;
  column-gap: 6px;
  box-sizing: border-box;
  padding: 0 16px;
  background-color: #f9f9f9;
  border-bottom: 1px solid #dfdfdf;
}

.dy_entrance {
  box-sizing: border-box;
  padding: 0 10px 0 6px;
  height: 26px;
  border: 1px solid #aec4ff;
  border-radius: 20px;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.icon_dy_img {
  width: 14px;
  height: 14px;
  display: block;
  margin-right: 4px;
  flex-shrink: 0;
}

.chat_input_body_div {
  width: 100%;
  height: calc(100%);
  display: flex;
}

.chat_upload_images_box {
  width: 160px;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-right: 1px solid #dfdfdf;
}

.chat_input_body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px 16px;
}

.reply_content {
  box-sizing: border-box;
  padding: 0 8px;
  height: 24px;
  background: #f6f6f6;
  border-radius: 2px;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  display: inline-flex;
  align-items: center;
  margin-bottom: 6px;
}

.reply_content_text {
  /* display: flex; */
}

.reply_content_text >>> p {
  margin: 0;
}

.reply_content .icon_close {
  flex-shrink: 0;
  margin-left: 5px;
  cursor: pointer;
  user-select: none;
}

.textarea_div {
  width: 100%;
  height: calc(100% - 32px - 10px);
}

.has_reply {
  height: calc(100% - 32px - 10px - 30px) !important;
}

.textarea_div /deep/.el-textarea {
  height: 100%;
}

.textarea_div /deep/.el-textarea__inner {
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  border: none !important;
  border-radius: 0 !important;
  padding: 0;
  resize: none;
  outline: none;
  /* font-family: Arial, sans-serif; */
  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  display: block;
}

.textarea_div textarea {
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  border: none;
  resize: none;
  outline: none;
  /* background-color: red; */
  /* font-family: Arial, sans-serif; */
  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  display: block;
}

.chat_input_handle_box {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.mr5 {
  font-size: 13px;
  color: #666666;
}
.icons {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.icon_emoji,
.icon_calculator {
  width: 20px;
  height: 20px;
  display: block;
  flex-shrink: 0;
  cursor: pointer;
  user-select: none;
}

.handles {
  display: flex;
  align-items: center;
}

.send_tip {
  margin-right: 8px;
  font-weight: 400;
  font-size: 12px;
  color: #bcbcbc;
}

.btn_submit {
  width: 70px;
  height: 32px;
  background-color: #4571e7;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.btn_submit_disabled {
  background-color: #c2d2ff !important;
  cursor: not-allowed;
}
</style>
